import { ComparisonTable } from 'ui/src/components/ComparisonTable/ComparisonTable'
import type { ComparisonTableBody, ComparisonTableHead } from 'ui/src/components/ComparisonTable/ComparisonTable.types'
import { type AddonComparisonFragment } from '@/services/graphql/generated'

export const addonComparisonToTable = (
  addonComparison: AddonComparisonFragment,
  baseTitle: string,
): { head: ComparisonTableHead; body: ComparisonTableBody } => {
  const head = ['', baseTitle, addonComparison.addonVariant.displayName]
  const body: ComparisonTableBody = addonComparison.rows.map((row) => {
    return [
      {
        title: row.title,
        description: row.description,
      },
      ...row.cells.map((cell, index) => {
        if (cell.coverageText) {
          return cell.coverageText
        } else if (cell.isCovered) {
          return <ComparisonTable.CoveredIcon key={index} />
        } else {
          return <ComparisonTable.NotCoveredIcon key={index} />
        }
      }),
    ]
  })
  return { head, body }
}
